import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelfServeLocalStorageUtil } from 'src/app/utils/local-storage.util';
import { AssignmentsDashboardComponent } from './assignments-dashboard/assignments-dashboard.component';
import { IAccountInfo } from 'src/app/interfaces/iaccount-info';
import { AssignmentConstants } from 'src/app/utils/constants/self-serve/assignment.constants';

@Component({
  selector: 'dashboard',
  standalone: true,
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [CommonModule, AssignmentsDashboardComponent],
})
export class DashboardComponent implements OnInit {
  assignmentsTabAccounts: IAccountInfo[] = [];
  simulationsTabAccounts: IAccountInfo[] = [];
  shouldShowDashboard: boolean = false;

  constructor() {}

  ngOnInit() {
    this.fetchAndPrepareAccounts();
  }

  private fetchAndPrepareAccounts(): void {
    try {
      const accountsStr = SelfServeLocalStorageUtil.getAccountsData();
      if (!accountsStr) {
        this.shouldShowDashboard = false;
        return;
      }

      const storedAccounts: IAccountInfo[] = JSON.parse(accountsStr);

      // Prepare accounts for assignments tab (AssignmentManager only)
      this.assignmentsTabAccounts =
        SelfServeLocalStorageUtil.filterAccountsByTab(
          storedAccounts,
          AssignmentConstants.ASSIGNMENTS_TAB
        );

      // Prepare accounts for simulations tab (Author or AssignmentManager)
      this.simulationsTabAccounts =
        SelfServeLocalStorageUtil.filterAccountsByTab(
          storedAccounts,
          AssignmentConstants.SIMULATIONS_TAB
        );

      // Show dashboard if there are any accounts available
      this.shouldShowDashboard =
        this.assignmentsTabAccounts.length > 0 ||
        this.simulationsTabAccounts.length > 0;
    } catch (error) {
      console.error('Error fetching and preparing accounts:', error);
      this.shouldShowDashboard = false;
    }
  }

  shouldShowNoAccess(): boolean {
    return !this.shouldShowDashboard;
  }
}
